import { APIAuth } from "../utils/API";

export const updateStoreStatus = async (status) => {
  return APIAuth.post(`seller/status`, { status })
    .then((res) => res.data)
    .catch((err) => err.data);
};
